import { render, staticRenderFns } from "./NewPassForm.vue?vue&type=template&id=d54af7ea"
import script from "./NewPassForm.vue?vue&type=script&lang=js"
export * from "./NewPassForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports